import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';

const route = new StepRoute(
  RouteNames.AppointmentSchedule,
  'schedule',
  () => import('@/views/steps/ScheduleStep.vue'),
);

route.showSummarySidebar();

export default route.getRoute();
